import {
    deserialisePeople,
    Person
} from '@api/lendingAPI/CustomerStateAPIHelper';
import {
    fetchGetStateByStateKey,
    GetStateByStateKeyResponse
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export type TCompanyShareholdersPeopleData = {
    company_shareholders: Person[];
    customerState: GetStateByStateKeyResponse;
};

export const useGetCompanyShareholdersData =
    (): TCompanyShareholdersPeopleData => {
        const stateKey = useStateKey();

        const { data: customerState } = useQuery({
            queryKey: ['customer_state', stateKey],
            queryFn: () => fetchGetStateByStateKey({ stateKey }),
            suspense: true
        });

        if (!customerState?.data?.application?.people) {
            throw new Error('Application people data is required');
        }

        const company_shareholders = deserialisePeople(
            customerState.data.application.people
        );

        return {
            company_shareholders,
            customerState
        };
    };
